import request from '@/router/axios'

const base = '/api/produce/road-outbound/auto-load-efficiency'

export const fetchKpi = (data) =>
  request({ url: `${base}/kpi`, method: 'post', data })

export const fetchLoadStageFunnel = (data) =>
  request({ url: `${base}/loadStageFunnel`, method: 'post', data })

export const fetchDurationTrend = (data) =>
  request({ url: `${base}/durationTrend`, method: 'post', data })

export const fetchBalanceCustAnalysis = (data) =>
  request({ url: `${base}/customerAnalysis`, method: 'post', data })

export const fetchDetailPage = (data) =>
  request({ url: `${base}/detailPage`, method: 'post', data })

/**
 * 客户(结算单位)远程检索：用于下拉展示
 * 后端：/api/produce/cust-info/select/distinct/pycode?custName={{query}}
 */
export const fetchCustPycodeDistinct = (custName) =>
  request({
    url: '/api/produce/cust-info/select/distinct/pycode',
    method: 'get',
    params: {
      custName
    }
  })

